import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { COOPERATION_ORGANIZATIONLIST } from 'manager/http-constants';
import { Table } from 'primeng/table';
import { CONSTANT } from 'src/app/shared/constant/constant';
import { LoadingState } from 'src/app/shared/html-parts/loading/loading-state';
import { CommonService } from 'src/app/shared/service/common.service';
import { DbOperationService } from 'src/app/shared/service/db-operation.service';
import { PlatformComponent } from '../platform.component';

@Component({
    selector: 'app-h104',
    templateUrl: './h104.component.html',
    styleUrls: ['./h104.component.scss', '../platform.component.scss'],
})

/**
 * 連携事例管理
 */
export class H104Component extends PlatformComponent {
    h104SearchForm: FormGroup = this.formBuilder.group({
        //ステータス
        status: '',
    });

    /** テーブル状態 */
    @ViewChild('table') table: Table;

    //ステータス取得格納先
    statusList: object[] = [
        {
            sp_name: '全て',
            sp_code: '',
        },
        {
            sp_name: '一時保存',
            sp_code: '0',
        },
        {
            sp_name: '未承認',
            sp_code: '1',
        },
        {
            sp_name: '承認',
            sp_code: '2',
        },
        {
            sp_name: '非承認',
            sp_code: '3',
        },
        {
            sp_name: '要修正',
            sp_code: '4',
        },
    ];

    // 連携事例管理リスト結果格納先
    resultDataList: object[] = new Array();

    // 件数格納先
    countData: number = 0;
    
    // セッション保存名
    sessionTagName: string = 'h104SearchConditions';

    constructor(
        public route: ActivatedRoute,
        public commonService: CommonService,
        public dbOperationService: DbOperationService,
        public loadingState: LoadingState,
        private router: Router,
        private formBuilder: FormBuilder
    ) {
        super(route, commonService, dbOperationService, loadingState);
    }

    ngOnInit(): void {
        // 連携事例管理リスト結果を取得
        this.getResultDataList();
    }

    /**
    * 初期処理:クエリパラメータの設定
    */
     private setQueryParams(): void {
        // クエリパラメータ.ステータス
        {
            // クエリパラメータ.ステータスを取得
            const status = this.route.snapshot.queryParams.status;

            // ステータスが存在するか否か
            if (status) {
                // ステータスが存在する場合

                //ステータスを画面.検索フォームに格納
                this.h104SearchForm
                .get('status')
                .setValue(status.split(CONSTANT.COMMA));
            }
        }
    }

    /**
     * 連携事例管理リスト結果を取得
    */
    public getResultDataList(screenSearchFlg?: boolean): void {
        // 画面ロードフラグをON(ロード中状態)
        let h104SearchForm: any = JSON.parse(
            JSON.stringify(this.h104SearchForm.value)
        );

        // 検索フォームが空の場合、セッションに保持している検索条件を設定
        if(!this.checkSetConditions(h104SearchForm) && !screenSearchFlg){
            let sessionSearchForm = JSON.parse(sessionStorage.getItem(this.sessionTagName));
            // セッションに値がなければ設定しない
            if(this.checkSetConditions(sessionSearchForm)){
                // 画面の検索条件に反映する
                this.h104SearchForm.setValue(sessionSearchForm);
                // 検索条件に設定する
                h104SearchForm = JSON.parse(
                    JSON.stringify(this.h104SearchForm.value)
                );
            }
        }

        // 配列をカンマ区切り変換
        {
            // ステータス種別
            h104SearchForm.status = h104SearchForm.status
            ? h104SearchForm.status.toString()
            : CONSTANT.EMPTY_STRING;
    
        }

        // 画面ロードフラグをON(ロード中状態)
        this.loadingState.loadStart(COOPERATION_ORGANIZATIONLIST);

        // 連携事例結果を取得
        this.dbOperationService
        .getNoTemplateData(COOPERATION_ORGANIZATIONLIST, h104SearchForm, true)
        .subscribe((response) => {
            if (!this.commonService.checkNoneResponse(response)) {
                // 課題・ソリューション結果を格納
                this.resultDataList = response.body;
            } else {
                this.resultDataList = new Array();
            }
            // 検索条件を保持
            sessionStorage.setItem(this.sessionTagName, JSON.stringify(this.h104SearchForm.value));

            // 画面ロードフラグをOFF(ロード終了)
            this.loadingState.loadSleepEnd(0.3, COOPERATION_ORGANIZATIONLIST);
        });

        // テーブル状態が存在するか否か
        if (this.table) {
            // テーブル状態が存在する場合

            // テーブル状態をリセット
            this.table.reset();
        }
    }

    /**
     * 検索条件を削除
     */
    public clearConditions(): void {
        // 検索条件を削除
        this.h104SearchForm.reset();
        this.h104SearchForm.setValue({status: ''});
    }

    /**
     * 連携事例登録(H101)へ遷移する
     */
    public moveH101(): void {
        // 連携事例登録(H101)へ遷移
        this.router.navigate(['pages/platform/h101/new'], {
            queryParams: {
                screenId: 'h101',
            },
        });
    }

    /**
     * 連携事例詳細(H301)へ遷移する
     * @param alignmentId 連携事例ID
     */
    public moveH301(alignmentId: string): void {
        // 連携事例詳細(H301)へ遷移
        this.router.navigate(['pages/platform/h301/' + alignmentId]);
    }

    /**
    * 検索条件が設定されているかチェックする
    * @param conditions
    * @returns boolean true:設定あり / false:未設定
    */
     public checkSetConditions(conditions: any): boolean {
        // 検索条件が存在するかチェック
        if(conditions === undefined || conditions === null){
            return false;
        } else {
            // 検索条件が設定されているかチェック
            if(conditions["status"] ){
                return true;
            }
        }
        return false;
    }
}